import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  useTheme,
  alpha,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  CheckCircle as CheckIcon,
  Cancel as CancelIcon,
  AccessTime as TimeIcon,
  FileDownload as ExportIcon,
  CalendarMonth as CalendarIcon,
} from '@mui/icons-material';

const Asistencia = () => {
  const theme = useTheme();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedArea, setSelectedArea] = useState('');

  const asistenciaData = [
    { id: 1, legajo: 'PL-001', nombre: 'Juan Rodríguez', area: 'Perforación', turno: '14x7', entrada: '06:00', salida: '18:00', estado: 'Presente', horas: 12 },
    { id: 2, legajo: 'PL-002', nombre: 'Pedro García', area: 'Workover', turno: '7x7', entrada: '06:00', salida: '18:00', estado: 'Presente', horas: 12 },
    { id: 3, legajo: 'PL-003', nombre: 'María López', area: 'Administración', turno: 'Normal', entrada: '08:00', salida: '17:00', estado: 'Presente', horas: 8 },
    { id: 4, legajo: 'PL-004', nombre: 'Carlos Mendoza', area: 'Seguridad', turno: '14x7', entrada: '-', salida: '-', estado: 'Licencia', horas: 0 },
    { id: 5, legajo: 'PL-005', nombre: 'Ana Martínez', area: 'Producción', turno: '7x7', entrada: '06:15', salida: '-', estado: 'Presente', horas: 0 },
    { id: 6, legajo: 'PL-006', nombre: 'Roberto Sánchez', area: 'Perforación', turno: '14x7', entrada: '-', salida: '-', estado: 'Ausente', horas: 0 },
  ];

  const estadoColor = (estado) => {
    switch (estado) {
      case 'Presente': return 'success';
      case 'Ausente': return 'error';
      case 'Licencia': return 'info';
      case 'Tardanza': return 'warning';
      default: return 'default';
    }
  };

  const resumenStats = [
    { label: 'Presentes', value: 245, total: 284, color: theme.palette.success.main },
    { label: 'Ausentes', value: 8, total: 284, color: theme.palette.error.main },
    { label: 'Licencia', value: 12, total: 284, color: theme.palette.info.main },
    { label: 'Franco', value: 19, total: 284, color: theme.palette.grey[500] },
  ];

  return (
    <Box className="fade-in">
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} color="primary">
            Control de Asistencia
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Registro de horas trabajadas y presentismo
          </Typography>
        </Box>
        <Button variant="outlined" startIcon={<ExportIcon />}>
          Exportar Reporte
        </Button>
      </Box>

      {/* Resumen */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {resumenStats.map((stat, index) => (
          <Grid item xs={6} sm={3} key={index}>
            <Card>
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h3" fontWeight={700} color={stat.color}>
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  de {stat.total} empleados
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Filtros */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Fecha"
                value={selectedDate}
                onChange={setSelectedDate}
                slotProps={{ textField: { fullWidth: true, size: 'small' } }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Área</InputLabel>
                <Select value={selectedArea} onChange={(e) => setSelectedArea(e.target.value)} label="Área">
                  <MenuItem value="">Todas</MenuItem>
                  <MenuItem value="Perforación">Perforación</MenuItem>
                  <MenuItem value="Workover">Workover</MenuItem>
                  <MenuItem value="Producción">Producción</MenuItem>
                  <MenuItem value="Administración">Administración</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Turno</InputLabel>
                <Select label="Turno" defaultValue="">
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="7x7">7x7</MenuItem>
                  <MenuItem value="14x7">14x7</MenuItem>
                  <MenuItem value="21x7">21x7</MenuItem>
                  <MenuItem value="Normal">Normal</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Estado</InputLabel>
                <Select label="Estado" defaultValue="">
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="Presente">Presente</MenuItem>
                  <MenuItem value="Ausente">Ausente</MenuItem>
                  <MenuItem value="Licencia">Licencia</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Tabla de Asistencia */}
      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
                  <TableCell>Legajo</TableCell>
                  <TableCell>Empleado</TableCell>
                  <TableCell>Área</TableCell>
                  <TableCell>Turno</TableCell>
                  <TableCell align="center">Entrada</TableCell>
                  <TableCell align="center">Salida</TableCell>
                  <TableCell align="center">Horas</TableCell>
                  <TableCell align="center">Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {asistenciaData.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>
                      <Chip label={row.legajo} size="small" variant="outlined" />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ width: 32, height: 32, bgcolor: theme.palette.primary.main, fontSize: '0.75rem' }}>
                          {row.nombre.split(' ').map(n => n[0]).join('')}
                        </Avatar>
                        {row.nombre}
                      </Box>
                    </TableCell>
                    <TableCell>{row.area}</TableCell>
                    <TableCell>
                      <Chip label={row.turno} size="small" color="info" variant="outlined" />
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2" fontWeight={500}>
                        {row.entrada}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2" fontWeight={500}>
                        {row.salida}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2" fontWeight={600} color={row.horas >= 8 ? 'success.main' : 'text.secondary'}>
                        {row.horas}h
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={row.estado}
                        size="small"
                        color={estadoColor(row.estado)}
                        icon={row.estado === 'Presente' ? <CheckIcon /> : row.estado === 'Ausente' ? <CancelIcon /> : <TimeIcon />}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Asistencia;
